
import { Typography } from "antd";
import React from 'react';

const{ Title, Text } = Typography;


export const SOW = () => {

	return (

		<>

		<Title level={ 4 }>STEP 1 - Determine Project Type</Title>
		<Title level={ 5 }>Ask the customer if the project is Commercial or Residential.</Title>
		<Text>Residential:  Assign immediatelly using Territory Lookup</Text><br/>
		<Text>Commercial:  Proceed to Step 2</Text>

		<Title level={ 4 }>STEP 2 - Check Professional Associations</Title>
		<Title level={ 5 }>Ask:  Are you associate with or working with an Architect, Builder, or Property Management Property?</Title>
		<Text>YES:  Proceed to Step 3</Text><br/>
		<Text>NO:  Skip to Step 4</Text>

		<Title level={ 4 }>STEP 3 -  Check SOW Commission Agents</Title>
		<Title level={ 5 }>3.  Identify the Commissioned Agent</Title>
		<Text>IF on the list AND in Robert Miller's SOW territory: Gather info & Email Robert Miller cc Monica.</Text><br/>
		<Text>IF not on the list BUT project falls outside of SOW territory:  Assign to SNA (Deidre) cc Monica</Text><br/>
		<Text>If NOT on the list: Proceed to Step 4</Text>

		<Title level={ 4 }>STEP 4 -  Salesforce Account Search</Title>
		<Title level={ 5 }>Search for the company in Salesforce</Title>
		<Text>FOUND:  IF in SOW territory schedule the project directly with the Customer Account Owner</Text><br/>
		<Text>Under SNA Record Owner Assign to SNA (Deidre) cc Monica</Text>
		<Text>NOT FOUND:  Proceed to Step 5.</Text>

		<Title level={ 4 }>STEP 5  Design Consultant Relationship</Title>
		<Title level={ 5 }>5.  Ask:  Do you currently work directly with one of our Design Consultants?</Title>
		<Text>YES:  Schedule the project with that specific Design Consultant</Text><br/>
		<Text>NO:  Assign using the Territory Lookup</Text>

		<Title level={ 4 }>Safety Nets & Escalations</Title>
		<Title level={ 5 }>6.  Unsure of Routing:  Gather ALL information - Create/Update the Salesforce Record & Email Monica.</Title>
		<Text>Plans or Estimate Request:  If you receive these and are unsure how to proceed, Email Monica.</Text>

		</>

	);

}